import { IntersectionType } from '@nestjs/swagger';
import { Exclude } from 'class-transformer';
import { BuilderInterface } from '../../builder/interfaces/builder.interface';
import { ArchivableEntityDto } from '../../common/dto/archivable-entity.dto';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { JobInterface } from '../../job/interfaces/job.interface';
import { SubdivisionInterface } from '../../subdivision/interfaces/subdivision.interface';
import { SupplierInterface } from '../../supplier/interfaces/supplier.interface';
import { ScheduledEmailsWeeklySupplierInterface } from '../interfaces/scheduled-emails-weekly-supplier.interface';

@Exclude()
export class ScheduledEmailsWeeklySupplierDto
  extends IntersectionType(CommonEntityDto, ArchivableEntityDto)
  implements ScheduledEmailsWeeklySupplierInterface
{
  jobId!: string;
  jobLot!: string;
  jobBlock!: string;
  builderId!: string;
  builderName!: string;
  modelId!: string;
  modelName!: string;
  subdivisionId!: string;
  subdivisionName!: string;
  supervisorUserIds!: string;
  supervisorFullNames!: string;
  orderNumber!: string;
  orderDate!: string;
  dateExpected!: string;
  supplierName!: string;
  address1!: string;
  address2!: string;
  city!: string;
  state!: string;
  zip!: string;
  supplierEmail!: string;
  job?: JobInterface | undefined;
  subdivision?: SubdivisionInterface | undefined;
  builder?: BuilderInterface | undefined;
  supplierId!: string;
  supplier?: SupplierInterface | undefined;
}
